/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '../../../../store'

import { fetchActivityCategories } from './apiActions/fetchActivityCategories'
import { fetchActivityList } from './apiActions/fetchActivityList'
import { initialState } from './initialActivityState'
import { IActivityMetaData, IActivityState } from './interface/IActivityState'

export const activitySlice = createSlice({
  name: 'activityList',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchActivityList.fulfilled, (state, action) => {
      state.list = action.payload
      state.metaData = action.payload.reduce<{
        [key: number]: IActivityMetaData
      }>(
        (accumulator, activity) => ({
          ...accumulator,
          [activity.id]: { color: activity.color, name: activity.name },
        }),
        {},
      )
      return state
    })

    builder.addCase(fetchActivityCategories.fulfilled, (state, action) => {
      state.categories = action.payload

      return state
    })
  },
})

export const activityStateSelector = (state: RootState): IActivityState =>
  state.activityNew
export const activityListSelector = (state: RootState) =>
  activityStateSelector(state).list

export const activityMetaDataSelector = (state: RootState) =>
  activityStateSelector(state).metaData

export const activityCategorySelector = (state: RootState) =>
  activityStateSelector(state).categories

export default activitySlice.reducer
